import { useEffect } from "react";
import type * as type from "@vTypes";
import ModalRowNurseRosterListView from "./ModalRowNurseRosterListView";
function ModalWeeklyOffTableBodyView({
  shiftInfo,
  year,
  month,
  nursesList,
  DaysInMonth,
}: {
  year?: number;
  month?: number;
  shiftInfo: any;
  nursesList?: any[];
  DaysInMonth?: number;
}) {
  useEffect(() => {
    const clickWindow = (e: Event) => {
      const clickTarget = e.target as HTMLElement;
      if (!clickTarget.closest(".preceptorMark")) {
        document
          .querySelectorAll(".preceptorGroup")
          .forEach((tr) => tr.classList.remove("click"));
      }
    };
    window.addEventListener("click", clickWindow);
    return () => {
      window.removeEventListener("click", clickWindow);
    };
  }, []);

  return nursesList && nursesList.length > 0 ? (
    <div className="pt-3">
      {nursesList.map((nurse, index) => {
        return (
          <ModalRowNurseRosterListView
            key={nurse.nurse_id}
            year={year}
            month={month}
            nurse={nurse}
            shiftInfo={shiftInfo}
            index={index + 1}
          />
        );
      })}
    </div>
  ) : (
    <div>
      <div className="text-center py-8 text-gray-500">
        간호사 목록이 없습니다.
      </div>
    </div>
  );
}

export default ModalWeeklyOffTableBodyView;
